import React from 'react';
import Icon from '../../../components/AppIcon';

const ActivityItem = ({ type, user, action, timestamp, details }) => {
  const getActivityIcon = () => {
    switch (type) {
      case 'registration':
        return { name: 'UserPlus', color: 'text-success' };
      case 'prediction':
        return { name: 'Target', color: 'text-primary' };
      case 'result':
        return { name: 'CheckCircle', color: 'text-success' };
      case 'tournament':
        return { name: 'Trophy', color: 'text-warning' };
      case 'system':
        return { name: 'Settings', color: 'text-muted-foreground' };
      default:
        return { name: 'Activity', color: 'text-foreground' };
    }
  };

  const formatTimestamp = (date) => {
    const now = new Date();
    const diff = now - date;
    const minutes = Math.floor(diff / 60000);
    const hours = Math.floor(diff / 3600000);
    const days = Math.floor(diff / 86400000);

    if (minutes < 1) return 'Just now';
    if (minutes < 60) return `${minutes}m ago`;
    if (hours < 24) return `${hours}h ago`;
    return `${days}d ago`;
  };

  const icon = getActivityIcon();

  return (
    <div className="flex items-start gap-3 md:gap-4 p-3 md:p-4 hover:bg-muted/50 rounded-lg transition-smooth">
      <div className={`${icon?.color} bg-muted p-2 md:p-2.5 rounded-lg flex-shrink-0`}>
        <Icon name={icon?.name} size={18} className="md:w-5 md:h-5" />
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between gap-2 mb-1">
          <p className="text-sm md:text-base text-foreground font-medium">
            <span className="font-semibold">{user}</span> {action}
          </p>
          <span className="text-xs md:text-sm text-muted-foreground whitespace-nowrap flex-shrink-0">
            {formatTimestamp(timestamp)}
          </span>
        </div>
        {details && (
          <p className="text-xs md:text-sm text-muted-foreground line-clamp-2">{details}</p>
        )}
      </div>
    </div>
  );
};

export default ActivityItem;